<template>
  <div
    class="bp-loading inset-0 flex items-center justify-center z-bp-loading"
    :class="fullscreen ? 'bp-loading--fullscreen fixed' : 'absolute'"
    :style="overlayStyle"
    role="alert"
    aria-live="polite"
    aria-busy="true"
  >
    <div class="bp-loading__box flex flex-col items-center gap-bp-2" :style="boxStyle">
      <bp-spinner size="lg" :color="color" :label="text || 'Carregando'" />
      <p
        v-if="text"
        class="bp-loading__text m-0 text-bp-sm leading-bp-sm font-bp-medium text-bp-text-strong text-center"
      >
        {{ text }}
      </p>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';
import BpSpinner from './BpSpinner.vue';

/**
 * Overlay de carregamento. Não é usado como tag em tela — quem o monta é o
 * serviço `loadingService.js` (`this.$bpLoading(...)`), que substitui a API
 * imperativa `$vs.loading` do Vuesax.
 */
export default defineComponent({
  name: 'BpLoadingOverlay',

  components: { BpSpinner },

  props: {
    /** Cobre a viewport inteira; falso cobre só o elemento-container. */
    fullscreen: { type: Boolean, default: false },

    /** Texto sob o spinner. Vazio mostra só o spinner. */
    text: { type: String, default: '' },

    /** Cor nomeada do `BpSpinner`. Vazio herda `currentColor`. */
    color: { type: String, default: '' },

    /** Fator de escala do spinner — equivale ao `scale` do `$vs.loading`. */
    scale: { type: [Number, String], default: 1 },

    /** Cor do véu. Vazio usa o token padrão. */
    background: { type: String, default: '' },
  },

  setup(props) {
    const overlayStyle = computed(() =>
      props.background ? { background: props.background } : {},
    );

    const boxStyle = computed(() => {
      const n = Number(props.scale);
      return n && n !== 1 ? { transform: `scale(${n})` } : {};
    });

    return { overlayStyle, boxStyle };
  },
});
</script>

<style scoped>
.bp-loading {
  background: rgba(255, 255, 255, 0.6);
}

.bp-loading__text {
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
}
</style>
